module.exports = __webpack_public_path__ + "public/img/Pelayanan Prima Untuk Staf Toko.ab378836.png";